/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerBagScanMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ScanEventFromUserInput>;
}>;


export type CustomerBagScanMutation = { __typename?: 'Mutation', scanAssetFromUser?: { __typename?: 'ScanEvent', id: string, material?: Types.MaterialType | null, entriesGained: number, createdByUser?: { __typename?: 'User', nearestDropOff?: any | null, contact: { __typename?: 'Contact', firstName?: string | null } } | null } | null };

export type UserScanMaterialConfirmMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserScanMaterialConfirmInput>;
}>;


export type UserScanMaterialConfirmMutation = { __typename?: 'Mutation', confirmBagMaterial?: { __typename?: 'ScanEvent', material?: Types.MaterialType | null } | null };


export const CustomerBagScanDocument = gql`
    mutation CustomerBagScan($input: ScanEventFromUserInput) {
  scanAssetFromUser(input: $input) {
    id
    material
    createdByUser {
      contact {
        firstName
      }
      nearestDropOff
    }
    entriesGained
  }
}
    `;
export type CustomerBagScanMutationFn = Apollo.MutationFunction<CustomerBagScanMutation, CustomerBagScanMutationVariables>;

/**
 * __useCustomerBagScanMutation__
 *
 * To run a mutation, you first call `useCustomerBagScanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerBagScanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerBagScanMutation, { data, loading, error }] = useCustomerBagScanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerBagScanMutation(baseOptions?: Apollo.MutationHookOptions<CustomerBagScanMutation, CustomerBagScanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerBagScanMutation, CustomerBagScanMutationVariables>(CustomerBagScanDocument, options);
      }
export type CustomerBagScanMutationHookResult = ReturnType<typeof useCustomerBagScanMutation>;
export type CustomerBagScanMutationResult = Apollo.MutationResult<CustomerBagScanMutation>;
export type CustomerBagScanMutationOptions = Apollo.BaseMutationOptions<CustomerBagScanMutation, CustomerBagScanMutationVariables>;
export const UserScanMaterialConfirmDocument = gql`
    mutation UserScanMaterialConfirm($input: UserScanMaterialConfirmInput) {
  confirmBagMaterial(input: $input) {
    material
  }
}
    `;
export type UserScanMaterialConfirmMutationFn = Apollo.MutationFunction<UserScanMaterialConfirmMutation, UserScanMaterialConfirmMutationVariables>;

/**
 * __useUserScanMaterialConfirmMutation__
 *
 * To run a mutation, you first call `useUserScanMaterialConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserScanMaterialConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userScanMaterialConfirmMutation, { data, loading, error }] = useUserScanMaterialConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserScanMaterialConfirmMutation(baseOptions?: Apollo.MutationHookOptions<UserScanMaterialConfirmMutation, UserScanMaterialConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserScanMaterialConfirmMutation, UserScanMaterialConfirmMutationVariables>(UserScanMaterialConfirmDocument, options);
      }
export type UserScanMaterialConfirmMutationHookResult = ReturnType<typeof useUserScanMaterialConfirmMutation>;
export type UserScanMaterialConfirmMutationResult = Apollo.MutationResult<UserScanMaterialConfirmMutation>;
export type UserScanMaterialConfirmMutationOptions = Apollo.BaseMutationOptions<UserScanMaterialConfirmMutation, UserScanMaterialConfirmMutationVariables>;